import { useState, useEffect, useMemo } from "react";
import Dropdown from "../components/Dropdown";
import DropdownFilter from "../components/DropdownFilter";
import InputIconSearch from "../components/InputIconSearch";
import InputIconSearchPanelMultiSelection from "../components/InputIconSearchPanelMultiSelection";
import InputData from "../components/InputData";
import ButtonIconH from "../components/ButtonIconH";
import Tag from "../components/Tag";
import TooltipBox from "../components/Tooltip";
import "../css/Panel.css";
import "../css/Patient.css";
import "../css/PatientSearch.css";
import "../css/custom-datatable.css";
import { post } from "../js/post";
import {
  LIMIT,
  userData,
  selectedOptic,
  provinceOptions,
  inputOnEnter,
  focusElement,
  formatValueUnit,
} from "../js/utils";
import DataTable from "react-data-table-component";
import { exportToFile } from "../support-extra/js/exportToFile";
import { transformPatientPicture } from "../support-extra/utils/patients";
import "../css/PatientResultRow.css";
import { useAmetropias } from "../hooks/useAmetropias";
import { useHobbies } from "../hooks/useHobbies";

export default function PatientSearch(props) {
  const [inputSearch, setInputSearch] = useState("");
  const [totalPatients, setTotalPatients] = useState("");
  const [patientList, setPatientList] = useState([]);
  const [toggleAdvancedSearch, setToggleAdvancedSearch] = useState(false);
  const [limit, setLimit] = useState(LIMIT);
  const [filterPatientWith, setFilterPatientWith] = useState([]);
  const [filterPreferences, setFilterPreferences] = useState([]);
  const [filterAmetropia, setFilterAmetropia] = useState([]);
  const [filterHobbies, setFilterHobbies] = useState([]);
  const [filterRange, setFilterRange] = useState("");
  const ametropiaList = useAmetropias();
  const hobbiesList = useHobbies();
  const [advancedSearchFields, setAdvancedSearchFields] = useState({
    provincia: "",
    nif: "",
    telefono: "",
    ametropias: [],
    aficiones: [],
    rxDesde: "",
    rxHasta: "",
    tipoFechaAlta: "",
  });

  const columns = useMemo(
    () => [
      {
        name: "",
        selector: (row) => row.fotoPaciente,
        sortable: false,
        width: "3%",
        cell: (row) => (
          <div>
            <img
              src={row.fotoPaciente}
              className="ps-user-img"
              alt="icon"
            ></img>
          </div>
        ),
      },
      {
        name: "Código",
        selector: (row) => row.codigo,
        sortable: true,
        width: "7%",
      },
      {
        name: "Nombre",
        selector: (row) => row.nombre,
        sortable: true,
        width: "15%",
      },
      {
        name: "Apellidos",
        selector: (row) => row.apellidos,
        sortable: true,
        width: "15%",
      },
      {
        name: "Preferencias",
        selector: (row) => row.preferencias,
        sortable: false,
        cell: (row) => (
          <div className="patient-prefs">
            {Object.entries(row.preferencias).map(
              ([preferencia, valor], index) => {
                return (
                  valor && (
                    <img
                      key={index}
                      src={`/images/${preferencia}.svg`}
                      className="icon-pref"
                      alt="icon"
                    />
                  )
                );
              },
            )}
          </div>
        ),
        width: "10%",
      },
      {
        name: "Dirección",
        selector: (row) => row.direccion,
        sortable: true,
        width: "12%",
      },
      {
        name: "Localidad",
        selector: (row) => row.localidad,
        sortable: true,
        width: "10%",
      },
      {
        name: "Teléfono",
        selector: (row) => row.telefono,
        sortable: true,
        width: "8%",
      },
      {
        name: "Email",
        selector: (row) => row.email,
        sortable: true,
        width: "auto",
      },
      {
        name: "",
        sortable: false,
        width: "3%",
        cell: (row) => (
          <div
            onClick={() =>
              window.open("/patient-datos/" + row.idPaciente, "_blank")
            }
          >
            <img
              src={`/images/eye-orange.svg`}
              className="icon-pref"
              alt="icon"
              data-tooltip-id={String(row.idPaciente)}
            ></img>
            <TooltipBox
              id={String(row.idPaciente)}
              content={
                <div className="opt-table-tooltip grid-5">
                  <div className="cell combined-cells-5 cell-start-content">
                    Abrir paciente en una nueva pestaña
                  </div>
                </div>
              }
            ></TooltipBox>
          </div>
        ),
      },
    ],
    [],
  );

  const searchPatients = async (from, total, add) => {
    const response = await post("BuscarPacientes.php", {
      token: userData.token,
      optica: selectedOptic.id,
      texto: inputSearch,
      pacientes: filterPatientWith,
      preferencias: filterPreferences,
      rango: filterRange,
      busquedaAvanzada: advancedSearchFields,
      start: from,
      total,
    });
    let patientListAux = response.pacientes;
    patientListAux.forEach((patient) => {
      patient.fotoPaciente = transformPatientPicture(patient.foto);
    });
    //let patientListAux = response.pacientes;
    /*patientListAux = await Promise.all(
      patientListAux.map(async (e) => {
        e.fotoPaciente = await getPatientPicture(e.idPaciente);
        return e;
      }),
    );*/
    if (add) {
      setPatientList([...patientList, ...patientListAux]);
    } else {
      setPatientList(patientListAux);
    }
  };

  const getTotalPatients = async () => {
    const response = await post("ObtenerNumPacientes.php", {
      token: userData.token,
      optica: selectedOptic.id,
    });
    setTotalPatients(response.num);
  };

  const exportPatientList = async (format) => {
    const table = {
      titulosTabla: [],
      numReferencias: "",
      extraCabeceras: [],
      cabeceras: [
        { titulo: "Código", tipo: "int", sumatorio: false },
        { titulo: "Nombre", tipo: "string", sumatorio: false },
        { titulo: "Apellidos", tipo: "string", sumatorio: false },
        { titulo: "Gafas", tipo: "string", sumatorio: false },
        { titulo: "Sol", tipo: "string", sumatorio: false },
        { titulo: "Audif.", tipo: "string", sumatorio: false },
        { titulo: "LC", tipo: "string", sumatorio: false },
        { titulo: "Dirección", tipo: "string", sumatorio: false },
        { titulo: "Localidad", tipo: "string", sumatorio: false },
        { titulo: "Teléfono", tipo: "string", sumatorio: false },
        { titulo: "Email", tipo: "string", sumatorio: false },
      ],
      filas: patientList.map((p) => [
        p.codigo,
        p.nombre,
        p.apellidos,
        p.preferencias.preferenciaGafasGraduadas ? "X" : "",
        p.preferencias.preferenciaGafasDeSol ? "X" : "",
        p.preferencias.preferenciaAudifonos ? "X" : "",
        p.preferencias.preferenciaLentillas ? "X" : "",
        p.direccion,
        p.localidad,
        p.telefono,
        p.email,
      ]),
    };

    await exportToFile(
      "Listado de pacientes",
      [],
      false,
      false,
      format,
      [table],
      -1,
      "",
    );
  };

  const validateDate = (e, op) => {
    const dateValue = e.target.value;
    const year = new Date(dateValue).getFullYear();

    if (year < 1900) {
      switch (op) {
        case 0:
          setAdvancedSearchFields({
            ...advancedSearchFields,
            rxDesde: "",
          });
          focusElement(7);
          break;
        case 1:
          setAdvancedSearchFields({
            ...advancedSearchFields,
            rxHasta: "",
          });
          focusElement(8);
          break;
        default:
          break;
      }
      return;
    }
  };

  const resetFilters = () => {
    setInputSearch("");
    setFilterPatientWith([]);
    setFilterPreferences([]);
    setFilterRange("");
    focusElement(1);
  };

  const resetAdvancedFilters = () => {
    const isAnyFieldFilled = Object.values(advancedSearchFields).some(
      (field) => field !== "",
    );

    if (isAnyFieldFilled) {
      setAdvancedSearchFields({
        provincia: "",
        nif: "",
        telefono: "",
        ametropias: [],
        aficiones: [],
        rxDesde: "",
        rxHasta: "",
        tipoFechaAlta: "",
      });
    }
    setFilterAmetropia([]);
    setFilterHobbies([]);
    focusElement(2);
  };

  useEffect(() => {
    if (props.show === true) {
      focusElement(1);
      getTotalPatients();
      searchPatients(
        0,
        patientList.length > limit ? patientList.length : limit,
        false,
      );
    }
  }, [props.show]);

  useEffect(() => {
    if (props.show === true) {
      focusElement(!toggleAdvancedSearch ? 1 : 2);
    }
  }, [toggleAdvancedSearch]);

  useEffect(() => {
    setAdvancedSearchFields({
      ...advancedSearchFields,
      ametropias: filterAmetropia,
    });
  }, [filterAmetropia]);

  useEffect(() => {
    setAdvancedSearchFields({
      ...advancedSearchFields,
      aficiones: filterHobbies,
    });
  }, [filterHobbies]);

  useEffect(() => {
    const timeoutId = setTimeout(() => {
      searchPatients(0, limit, false);
    }, 500);
    return () => clearTimeout(timeoutId);
  }, [inputSearch]);

  useEffect(() => {
    searchPatients(0, limit, false);
  }, [
    filterPatientWith,
    filterPreferences,
    filterAmetropia,
    filterHobbies,
    filterRange,
    advancedSearchFields,
    limit,
  ]);

  if (!props.show) {
    return <></>;
  }

  return (
    <div className="patient-data">
      <div className="patient-data-header">
        <span className="header-text">Pacientes</span>
      </div>
      <div className="patient-data-content">
        <div className="action-bar">
          <div className="action-bar-resume">
            <span>Pacientes</span>
            <span>|</span>
            <span className="signed-text">Búsqueda de pacientes</span>
          </div>
        </div>
        <div className="patient-search-content">
          <div
            className="opt-table-title"
            style={{ width: "100%", justifyContent: "space-between" }}
          >
            <span>Búsqueda de pacientes</span>
            <button className="cell-label" onClick={resetFilters} tabIndex={-1}>
              Limpiar filtros
            </button>
          </div>
          <div className="ps-parameters">
            <InputIconSearch
              tabIndex={1}
              id="search"
              size={3}
              placeholder={"Nombre, apellidos, dirección..."}
              input={inputSearch}
              onChange={async (e) => {
                setInputSearch(e);
              }}
              onClear={async () => {
                setInputSearch("");
              }}
            ></InputIconSearch>
            <DropdownFilter
              icon={"/images/time-blue.svg"}
              size={3}
              optionList={[
                {
                  id: "optometria",
                  text: "CON OPTOMETRÍA",
                  active: filterPatientWith.includes("optometria"),
                },
                {
                  id: "audiometria",
                  text: "CON AUDIOMETRÍA",
                  active: filterPatientWith.includes("audiometria"),
                },
                {
                  id: "encargo",
                  text: "CON ENCARGO",
                  active: filterPatientWith.includes("encargo"),
                },
                {
                  id: "venta",
                  text: "CON VENTA",
                  active: filterPatientWith.includes("venta"),
                },
              ]}
              op={"Pacientes"}
              selectedOptions={filterPatientWith}
              onChange={(e) => {
                const updatedFilterPatientWith = filterPatientWith.includes(
                  e.id,
                )
                  ? filterPatientWith.filter((p) => p !== e.id)
                  : [...filterPatientWith, e.id];
                setFilterPatientWith(updatedFilterPatientWith);
              }}
            ></DropdownFilter>
            <DropdownFilter
              icon={"/images/prefs-blue.svg"}
              size={3}
              optionList={[
                {
                  id: "gafas",
                  text: "GAFAS",
                  active: filterPreferences.includes("gafas"),
                },
                {
                  id: "gafasdesol",
                  text: "GAFAS DE SOL",
                  active: filterPreferences.includes("gafasdesol"),
                },
                {
                  id: "lentesdecontacto",
                  text: "LENTES DE CONTACTO",
                  active: filterPreferences.includes("lentesdecontacto"),
                },
                {
                  id: "audifonos",
                  text: "AUDÍFONOS",
                  active: filterPreferences.includes("audifonos"),
                },
              ]}
              op={"Preferencias"}
              selectedOptions={filterPreferences}
              onChange={(e) => {
                const updatedFilterPreferences = filterPreferences.includes(
                  e.id,
                )
                  ? filterPreferences.filter((p) => p !== e.id)
                  : [...filterPreferences, e.id];
                setFilterPreferences(updatedFilterPreferences);
              }}
            ></DropdownFilter>
            <DropdownFilter
              icon={"/images/date-blue.svg"}
              size={3}
              optionList={[
                {
                  id: 7,
                  text: "ÚLTIMOS 7 DÍAS",
                  active: filterRange === 7,
                },
                {
                  id: 15,
                  text: "ÚLTIMOS 15 DÍAS",
                  active: filterRange === 15,
                },
                {
                  id: 30,
                  text: "ÚLTIMOS 30 DÍAS",
                  active: filterRange === 30,
                },
                { id: 365, text: "ÚLTIMO AÑO", active: filterRange === 365 },
                { id: "", text: "CUALQUIER FECHA", active: filterRange === "" },
              ]}
              op={filterRange}
              selectedOptions={[]}
              onChange={(e) => {
                if (e.id !== filterRange) {
                  setFilterRange(e.id);
                }
              }}
            ></DropdownFilter>
          </div>
          <div
            className="opt-table-title"
            style={{
              width: "100%",
              justifyContent: "space-between",
              marginTop: 10,
            }}
          >
            <div style={{ display: "flex", gap: 10, alignItems: "center" }}>
              <span>Búsqueda avanzada</span>
              <button
                className="cell-icon"
                onClick={() => {
                  setToggleAdvancedSearch(!toggleAdvancedSearch);
                }}
              >
                <img
                  src={
                    toggleAdvancedSearch
                      ? "/images/arrow-up-blue.svg"
                      : "/images/arrow-down-blue.svg"
                  }
                  loading="lazy"
                  alt="Icon"
                  className="cell-icon"
                ></img>
              </button>
            </div>
            {toggleAdvancedSearch && (
              <button
                className="cell-label"
                onClick={resetAdvancedFilters}
                tabIndex={-1}
              >
                Limpiar filtros
              </button>
            )}
          </div>
          {toggleAdvancedSearch && (
            <div className="advanced-search-cols">
              <div className="advanced-search-col">
                <div className="data-field">
                  <span className="label">Provincia</span>
                  <Dropdown
                    tabIndex={2}
                    disabled={false}
                    optionList={provinceOptions}
                    size={3}
                    op={advancedSearchFields.provincia}
                    onChange={(e) => {
                      setAdvancedSearchFields({
                        ...advancedSearchFields,
                        provincia: e.text,
                      });
                    }}
                  ></Dropdown>
                </div>
                <div className="data-field">
                  <span className="label">NIF</span>
                  <InputData
                    type="type-only-charnumbers"
                    size={3}
                    tabIndex={3}
                    input={advancedSearchFields.nif}
                    maxLength={12}
                    onChange={(e) => {
                      setAdvancedSearchFields({
                        ...advancedSearchFields,
                        nif: e,
                      });
                    }}
                  ></InputData>
                </div>
                <div className="data-field">
                  <span className="label">Teléfono</span>
                  <InputData
                    type="type-phone"
                    size={3}
                    tabIndex={4}
                    maxLength={20}
                    input={advancedSearchFields.telefono}
                    onChange={(e) => {
                      setAdvancedSearchFields({
                        ...advancedSearchFields,
                        telefono: e,
                      });
                    }}
                  ></InputData>
                </div>
              </div>
              <div className="advanced-search-col">
                <div className="data-field">
                  <span className="label">Rx desde</span>
                  <input
                    type="date"
                    max="9999-12-31"
                    tabIndex={7}
                    className="input-field"
                    value={advancedSearchFields.rxDesde}
                    style={{ width: "200px" }}
                    onChange={(e) => {
                      setAdvancedSearchFields({
                        ...advancedSearchFields,
                        rxDesde: e.target.value,
                      });
                    }}
                    onBlur={(e) => {
                      validateDate(e, 0);
                    }}
                    onKeyUp={(e) => inputOnEnter(e)}
                  ></input>
                </div>
                <div className="data-field">
                  <span className="label">Rx hasta</span>
                  <input
                    type="date"
                    max="9999-12-31"
                    tabIndex={8}
                    className="input-field"
                    value={advancedSearchFields.rxHasta}
                    style={{ width: "200px" }}
                    onChange={(e) => {
                      setAdvancedSearchFields({
                        ...advancedSearchFields,
                        rxHasta: e.target.value,
                      });
                    }}
                    onBlur={(e) => {
                      validateDate(e, 1);
                    }}
                    onKeyUp={(e) => inputOnEnter(e)}
                  ></input>
                </div>
                <div className="data-field">
                  <span className="label">Fecha alta</span>
                  <DropdownFilter
                    icon={"/images/date-blue.svg"}
                    optionList={[
                      {
                        id: 7,
                        text: "ÚLTIMOS 7 DÍAS",
                        active: advancedSearchFields.tipoFechaAlta === 7,
                      },
                      {
                        id: 15,
                        text: "ÚLTIMOS 15 DÍAS",
                        active: advancedSearchFields.tipoFechaAlta === 15,
                      },
                      {
                        id: 30,
                        text: "ÚLTIMOS 30 DÍAS",
                        active: advancedSearchFields.tipoFechaAlta === 30,
                      },
                      {
                        id: 365,
                        text: "ÚLTIMO AÑO",
                        active: advancedSearchFields.tipoFechaAlta === 365,
                      },
                      {
                        id: "",
                        text: "CUALQUIERA",
                        active: advancedSearchFields.tipoFechaAlta === "",
                      },
                    ]}
                    op={advancedSearchFields.tipoFechaAlta}
                    selectedOptions={[]}
                    onChange={(e) => {
                      setAdvancedSearchFields((prev) => ({
                        ...prev,
                        tipoFechaAlta: e.id,
                      }));
                    }}
                  ></DropdownFilter>
                </div>
              </div>
              <div className="advanced-search-col" style={{ flex: 1 }}>
                <div className="data-field">
                  <span className="label">Ametropías</span>
                  <InputIconSearchPanelMultiSelection
                    size={0}
                    tabIndex={9}
                    type={"type-alphanum-ext"}
                    options={ametropiaList.map((e) => e.text)}
                    selectedOptions={filterAmetropia}
                    onChange={(e) => {
                      setFilterAmetropia(e);
                    }}
                  ></InputIconSearchPanelMultiSelection>
                </div>
                {filterAmetropia.length > 0 && (
                  <span style={{ fontWeight: "500", fontSize: 13 }}>
                    Ametropías seleccionadas: {filterAmetropia.length}
                  </span>
                )}
                {filterAmetropia.length > 0 && (
                  <div className="tag-content">
                    {filterAmetropia.map((e, i) => {
                      return (
                        <Tag
                          text={e}
                          key={i}
                          tagId={i}
                          onClick={(e) => {
                            setFilterAmetropia((prev) =>
                              prev.filter((element) => element !== e),
                            );
                          }}
                        ></Tag>
                      );
                    })}
                  </div>
                )}
                <div className="data-field">
                  <span className="label">Aficiones</span>
                  <InputIconSearchPanelMultiSelection
                    size={0}
                    tabIndex={10}
                    type={"type-alphanum-ext"}
                    options={hobbiesList.map((e) => e.text)}
                    selectedOptions={filterHobbies}
                    onChange={(e) => {
                      setFilterHobbies(e);
                    }}
                  ></InputIconSearchPanelMultiSelection>
                </div>
                {filterHobbies.length > 0 && (
                  <span style={{ fontWeight: "500", fontSize: 13 }}>
                    Aficiones seleccionadas: {filterHobbies.length}
                  </span>
                )}
                {filterHobbies.length > 0 && (
                  <div className="tag-content">
                    {filterHobbies.map((e, i) => {
                      return (
                        <Tag
                          text={e}
                          key={i}
                          tagId={i}
                          onClick={(e) => {
                            setFilterHobbies((prev) =>
                              prev.filter((element) => element !== e),
                            );
                          }}
                        ></Tag>
                      );
                    })}
                  </div>
                )}
              </div>
            </div>
          )}
        </div>
        <div className="patient-search-result-content">
          <div className="psr-header">
            <div className="ps-title">
              <div className="title-h2">
                Listado de pacientes ({formatValueUnit(patientList.length)} de{" "}
                <span style={{ color: "#41b3ff" }}>
                  {formatValueUnit(totalPatients)}
                </span>
                )
              </div>
            </div>
            <div className="psr-parameters">
              <DropdownFilter
                disabled={false}
                optionList={[
                  { id: "00", text: "25", active: limit === 25 },
                  { id: "01", text: "50", active: limit === 50 },
                  { id: "02", text: "100", active: limit === 100 },
                ]}
                op={"Mostrando " + limit}
                selectedOptions={[]}
                onChange={(e) => {
                  setLimit(parseInt(e.text));
                }}
              ></DropdownFilter>
              <DropdownFilter
                disabled={false}
                optionList={[
                  { id: "csv", text: "CSV" },
                  { id: "excel", text: "Excel" },
                  { id: "pdf", text: "PDF" },
                ]}
                op={"EXPORTAR COMO"}
                selectedOptions={[]}
                onChange={(e) => {
                  exportPatientList(e.id);
                }}
              ></DropdownFilter>
              <ButtonIconH
                text="Nuevo paciente"
                highlight={true}
                onClick={() => {
                  props.onClickMenuOption("patient-datos", {
                    patientId: -1,
                  });
                }}
              ></ButtonIconH>
            </div>
          </div>
          <div className="breaker-gr mb-8"></div>
          <DataTable
            columns={columns}
            data={patientList}
            className="custom-datatable"
            noDataComponent="No hay pacientes disponibles."
            onRowClicked={(row, event) => {
              props.onClickMenuOption("patient-datos", {
                patientId: row.idPaciente,
              });
            }}
          />
          <ButtonIconH
            text="Ver más"
            small={true}
            onClick={() => {
              if (patientList.length < totalPatients) {
                searchPatients(patientList.length, limit, true);
              }
            }}
          ></ButtonIconH>
        </div>
      </div>
    </div>
  );
}
